<template>
    <div>
        <div>
            <div  v-if="$store.getters.isUserImpersonated" class="impersonatedUserHeader">
            You are impersonating the user : {{$store.getters.username}}
        </div>
            <Header />
            <div id="error" class="container">
                <h3>You are not authorized to access this page.</h3>
                <span v-html="$store.getters.errorMessage"></span>
                <p>Click <router-link to="/logoff">here</router-link> to log off. </p>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapActions } from "vuex";
    import Header from "./shared/Header";
    export default {
        name: "Unauthorizederror",
        components: {
            Header
        },
        data() {
            return {
            };
        },
        methods: {
            ...mapActions("oidcStore", [
                "authenticateOidc"
            ]),
        }
    };
</script>